export const DEFAULT_ORDER_SORT_OPTIONS = 0;
export const ASC = "ASC";
export const DESC = "DESC";
